import { Helmet } from "react-helmet-async";

const SITE_NAME = "Je Voyage Ici";
const SITE_URL = "https://jevoyageici.com";
const DEFAULT_IMAGE = "/images/preview-bg.png";

const Seo = ({
    title,
    description,
    canonical,
    image = DEFAULT_IMAGE,
    type = "website",
}) => {
    const pageUrl = canonical.startsWith("http")
        ? canonical
        : `${SITE_URL}${canonical}`;

    const imageUrl = image.startsWith("http")
        ? image
        : `${SITE_URL}${image}`;

    return (
        <Helmet>
            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />

            <link
                rel="canonical"
                href={pageUrl}
            />

            <meta property="og:type" content={type} />

            <meta
                property="og:site_name"
                content={SITE_NAME}
            />

            <meta
                property="og:title"
                content={title}
            />

            <meta
                property="og:description"
                content={description}
            />

            <meta
                property="og:url"
                content={pageUrl}
            />

            <meta
                property="og:image"
                content={imageUrl}
            />

            <meta
                property="og:locale"
                content="fr_DZ"
            />

            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <meta
                name="twitter:title"
                content={title}
            />

            <meta
                name="twitter:description"
                content={description}
            />

            <meta
                name="twitter:image"
                content={imageUrl}
            />
        </Helmet>
    );
};

export default Seo;